import { gql } from '@apollo/client';

export const LOG_SOLERA_ENROLLMENT_ATTEMPT = gql`
  mutation LogSoleraEnrollmentAttempt(
    $enrollmentIdentifier: String!
    $stage: String!
    $failureReason: String
    $metadata: JSON
  ) {
    logSoleraEnrollmentAttempt(
      enrollmentIdentifier: $enrollmentIdentifier
      stage: $stage
      failureReason: $failureReason
      metadata: $metadata
    ) {
      success
    }
  }
`;

export interface LogSoleraEnrollmentAttemptResponse {
  logSoleraEnrollmentAttempt: {
    success: boolean;
  };
}

export interface LogSoleraEnrollmentAttemptVariables {
  enrollmentIdentifier: string;
  stage: 'visit' | 'fetch_attempted' | 'fetch_succeeded' | 'fetch_failed';
  failureReason?: string;
  metadata?: Record<string, unknown>;
}
